module.exports = __webpack_public_path__ + "img/20190813160549275.0b9321be.png";